export const bagDeliveryBikouStr = 'バッグ配達';
